<template>
  <div v-click-outside="hide" class="filter-select">
    <div class="filter-select__wrap">
      <p class="filter-select__label">{{ title }}</p>
      <a class="filter-select__field" href="#" @click.prevent="toggle">{{ selected }} <Chevron class="filter-select__arrow" /></a>
      
      <div v-if="active" class="filter-select__dropdown">
        <ul>
          <li><a href="#" @click.prevent="select({ label: 'All', value: ''})">All</a></li>
          <li v-for="(option, index) in options" :key="index"><a href="#" @click.prevent="select(option)">{{ option.label }}</a></li>
        </ul>
      </div>
    </div>
    <p v-if="error" class="filter-select__error">{{ loadErrorMsg }}</p>
  </div>
</template>

<script>
import { selectedFilter } from '~/utils/gtm-events.js';

export default {
  props: {
    title: {
      default: 'Filter posts by:',
      type: String,
      required: true,
    },
    defaultFilterLabel: { type: String, required: true },
    options: {
      type: Array,
      required: true,
    },
    filterChange: {
      type: Function,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loadErrorMsg: 'Error filtering posts!',
      selected: 'All',
      active: false,
    };
  },
  methods: {
    select(option) {
      this.selected = option.label;
      selectedFilter(this.$gtm, this.selected);
      this.filterChange(option.value);
      this.active = false;
    },
    hide() {
      this.active = false;
    },
    toggle() {
      this.active = !this.active;
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/elements/_filter-select.scss';
</style>
